import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-icon-callout-blue",
  "use": "svg-icon-icon-callout-blue-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-icon-callout-blue\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M22.077 18.499a12.006 12.006 0 10-4.18 3.945l3.974 1.064a.997.997 0 001.221-1.222l-1.015-3.787\" fill=\"#3AA9DF\" /><path d=\"M10.492 7.219a1.508 1.508 0 11.441 1.065 1.452 1.452 0 01-.44-1.065zm.208 2.65h2.598v8.42H10.7v-8.42z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol